export default __webpack_public_path__ + "static/media/Coverage_white.6a154e3f.svg";